export enum MenuItemGroup {
  PROPERTY_HOLDINGS = 'property_holdings',
  SALES = 'sales',
  INVOICING = 'invoicing',
  MY_ORGANIZATION = 'my_organization',
  HELP = 'help',
}
